class ProfileStore {
    apiKey = $state('');
    secretKey = $state('');
    hasKeys = $state(false);
    editing = $state(false);
}

export const profileStore = new ProfileStore();
